import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { Groups2Rounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoGroupContacts = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.contactsGroup.noContacts.primary')}
            secondary={t('prompts:noData.contactsGroup.noContacts.secondary')}
            Icon={Groups2Rounded}
            action={
                <Button
                    variant="tonal"
                    color="secondary"
                    LinkComponent={Link}
                    to="/contacts"
                >
                    {t('Go To Contacts')}
                </Button>
            }
        />
    );
};

export default NoGroupContacts;
